module.exports = __webpack_public_path__ + "static/media/creativ8.06087ce7.jpg";